import { FunctionComponent, memo, useContext } from 'react';
import { UserContext } from '../../../../context';
import {
  DeeplinkType,
  getDeepLinkUrl,
  getStoryCardIntro,
  getStoryCardPreviewUrl,
  getStoryCardSource,
  getStoryCardTitle,
  ImageFile,
  StoryCardBlockData,
  StoryCardMediaPlaceholder,
} from '../../../../shared';
import { EmbedLink } from '../EmbedLink';

export const StoryCard: FunctionComponent<StoryCardBlockData> = memo(({ storyCard }) => {
  const { channelId } = useContext(UserContext).userInfo.userData;

  if (!storyCard) {
    return null;
  }

  const { storyId, id: cardId, type } = storyCard;

  const sourceName = getStoryCardSource(storyCard);

  const title = getStoryCardTitle(storyCard);

  const text = getStoryCardIntro(storyCard);

  const imageUrl = getStoryCardPreviewUrl(storyCard);

  const url = getDeepLinkUrl({ type: DeeplinkType.CARD, channelId, storyId, cardId });

  if ([sourceName, title, text, imageUrl].every((value) => !Boolean(value))) {
    return <StoryCardMediaPlaceholder url={url} type={type} />;
  }

  return (
    <EmbedLink
      link={{ url, sourceName, title, text, image: { url: imageUrl } as ImageFile }}
      hideUrl
    />
  );
});
